var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "empty-withdrawal-widget",
      attrs: { "data-test-id": "empty-withdrawal-widget" }
    },
    [
      _c(
        "md-icon",
        { attrs: { "data-test-id": "empty-withdrawal-widget-icon" } },
        [_vm._v("\n    credit_card\n  ")]
      ),
      _vm._v(" "),
      _c("p", { attrs: { "data-test-id": "empty-withdrawal-widget-msg1" } }, [
        _vm._v("\n    " + _vm._s(_vm.i18n.withdraw_no_assets()) + "\n  ")
      ]),
      _vm._v(" "),
      _c("p", { attrs: { "data-test-id": "empty-withdrawal-widget-msg2" } }, [
        _vm._v("\n    " + _vm._s(_vm.i18n.withdraw_no_assets_exp()) + "\n  ")
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-44ba0274", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44ba0274","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/dashboard/widgets/WithdrawalWidget/EmptyWidgetStub.vue
// module id = 0cd4
// module chunks = 1